const indexes = [
  {
    label: '悬疑烧脑',
    count: '86部',
    desc: '国产悬疑推理佳作合集',
    icon: 'ri-search-eye-line',
  },
  {
    label: '动作猛片',
    count: '124部',
    desc: '高燃打斗场面精选',
    icon: 'ri-fire-line',
  },
  {
    label: '喜剧合集',
    count: '95部',
    desc: '爆笑不停欢乐不断',
    icon: 'ri-emotion-happy-line',
  },
  {
    label: '文艺剧情',
    count: '73部',
    desc: '感人至深的口碑好片',
    icon: 'ri-heart-line',
  },
  {
    label: '科幻纪元',
    count: '48部',
    desc: '脑洞大开的视觉盛宴',
    icon: 'ri-rocket-line',
  },
  {
    label: '历史古装',
    count: '62部',
    desc: '匠心还原历史风云',
    icon: 'ri-ancient-gate-line',
  },
  {
    label: '国漫崛起',
    count: '57部',
    desc: '国产动画精品推荐',
    icon: 'ri-movie-2-line',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            专题合集
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            按类型与主题整理的国产电影索引，方便你快速浏览
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {indexes.map((item) => (
            <a
              key={item.label}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#cards');
                if (el) {
                  const top = el.getBoundingClientRect().top + window.pageYOffset - 80;
                  window.scrollTo({ top, behavior: 'smooth' });
                }
              }}
              className="group flex flex-col items-center text-center p-4 md:p-5 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="mt-3 text-sm font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {item.label}
              </h3>
              <span className="mt-1 text-xs text-foreground-500">{item.count}</span>
              <p className="mt-1 text-xs text-foreground-600 hidden md:block">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}